import { Component, EventEmitter, Input, Output } from '@angular/core';

import { fillSkeletonData } from 'src/app/@shared/app-helper';

import { RoleModel } from 'src/app/role/@shared/role.model';

@Component({
  // use onPush approach when performance is poor
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'role-preview',
  standalone: false,
  styleUrls: ['./role-preview.component.scss'],
  templateUrl: './role-preview.component.html',
})
export class RolePreviewComponent {
  @Input() public type: 'thumbnail' | 'avatar' | 'card';

  @Output() public openDetail: EventEmitter<RoleModel> = new EventEmitter<RoleModel>();

  public showSkeleton: boolean = true;

  // fill item with skeleton data
  // !!!IMPORTANT!!! always use a skeleton wrapper (<span class="skeleton">...</span>) around the value
  // to ensure skeleton text (single- as well as multiline) works as expected
  private _item: Partial<RoleModel> = {
    displayName: fillSkeletonData('title'),
  };

  @Input()
  public get item(): RoleModel {
    return this._item as RoleModel;
  }

  public set item(item: RoleModel | null) {
    // item is initially null (skeleton)
    if (!item) {
      return;
    }

    this._item = item as Partial<RoleModel>;
    this.showSkeleton = false;
  }
}
